import * as localforage from 'localforage';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import * as Sentry from '@sentry/angular';
import { CacheService } from '@shared/services';
import { VaultService } from '@shared/services/core/vault.service';

@Injectable({ providedIn: 'root' })
export class AppService {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(
		private readonly menu: MenuController,
		private readonly cache: CacheService,
		private readonly vaultService: VaultService,
		private readonly router: Router
	) {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - logout
	 **-------------------------------------------------------------------------------------
	 */
	async logout() {
		const code = await this.cache.get('secure:code');
		const email = await this.cache.get('secure:email');
		await this.cache.clear();
		await this.cache.set('secure:code', code);
		await this.cache.set('secure:email', email);
		await this.vaultService.unlockVault();
		await this.vaultService.setSession('');
		this.menu.enable(false);
		localforage.clear();
		localStorage.clear();
		sessionStorage.clear();
		if (indexedDB.databases) {
			indexedDB.databases().then(dbs => {
				var promises = dbs.map(db => {
					return new Promise((resolve, reject) => {
						var req = indexedDB.deleteDatabase(db.name);
						req.onsuccess = resolve;
						req.onerror = reject;
						req.onblocked = reject;
					});
				});
				Promise.all(promises).then(console.log).catch(console.error);
			});
		}
		await Sentry.close(2000);

		return this.router.navigateByUrl('/login');
	}
}
